<!-- 创建人-修改弹框 -->
<template lang="pug">
van-action-sheet(v-model="popupShow" cancel-text="清空" close-on-click-action @closed="close" @cancel="clear")
  van-search(v-model="keyword" placeholder="请输入关键词")
  button.van-action-sheet__item(v-for="(item,index) in modifierList" :key="index" :class="item.isSelected? 'isSelected':''" @click="onSelect(item)") {{ item.name }} 
    i.el-icon-check.el-icon--right(v-if="item.isSelected")
</template>

<script>
import { mapState } from "vuex";
import questionService from "@/CommonDP/service/question-service";

export default {
  components: {},
  data() {
    return {
      popupShow: false,
      actions: [], // 选项
      keyword: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    // 过滤后的修改人
    modifierList() {
      return this.actions.filter((e) => e.name?.includes(this.keyword));
    }
  },
  mounted() {},
  methods: {
    // 初始化
    async init(prjId, fileId, list) {
      await this.getDic(prjId, fileId);
      // 默认选中项
      if (list) {
        this.actions.forEach((e) => {
          if (list.some((item) => item.modifierName === e.name)) this.$set(e, "isSelected", true);
        });
      }
    },
    // 清空
    clear() {
      this.actions.forEach((e) => {
        this.$set(e, "isSelected", false);
      });
      this.$emit("callback", []);
    },

    // 获得可选值
    async getDic(prjId, fileId) {
      let dicList = {};
      if (prjId && !fileId) {
        const { data } = await questionService.getH5DrawingQuestionSearchList(prjId);
        dicList = data || {};
      } else if (prjId && fileId) {
        const { data } = await questionService.queryDict2(prjId, fileId);
        dicList = data || {};
      }
      let createUserList = dicList.createUserList || [];
      this.actions = createUserList.map((e) => {
        return { id: e.userId, ...e };
      });
    },
    // 选中事件
    onSelect(item) {
      if (item.isSelected) this.$set(item, "isSelected", false);
      else this.$set(item, "isSelected", true);
      this.callback();
    },
    // 回调
    callback() {
      let selectedList = this.actions.filter((e) => e.isSelected);
      this.$emit("callback", selectedList);
    },

    // 关闭事件
    close() {
      this.keyword = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.isSelected {
  color: var(--theme-color, #4777e7);
}
</style>
